<!--登录信息-->
<template>
  <div class="main-pc">
    <div class="box">
      <div class="left"></div>
      <div class="right">
        <div class="title">请仔细填写以下信息进行答题</div>
        <Form class="form-box" ref="formInline" :model="loginFrom" :rules="loginFromRules" inline>
          <div class="form-overflow">
            <Form-item prop="name" v-if="isName">
              <Input type="text" size="large" v-model="loginFrom.name" placeholder="请输入姓名">
                <i class="iconfont iconwo" slot="prepend"></i>
              </Input>
            </Form-item>
            <Form-item prop="sex" v-if="isSex">
              <Select v-model="loginFrom.sex"
                      size="large"
                      @on-change="choseSex"
                      placeholder="请选择性别">
                <Option value="男">男</Option>
                <Option value="女">女</Option>
              </Select>
            </Form-item>
            <Form-item prop="age" v-if="isAge">
              <Select v-model="loginFrom.age"
                      @on-change="choseAge"
                      size="large"
                      placeholder="请选择年龄段">
                <Option v-for="item in ageArr"
                        :value="item.value"
                        :key="item.value">
                  {{ item.label }}
                </Option>
              </Select>
            </Form-item>
            <Form-item prop="danwei" v-if="isDanWei">
              <Input type="text" size="large" v-model="loginFrom.danwei" placeholder="请输入单位名称">
                <i class="iconfont icondanwei" slot="prepend"></i>
              </Input>
            </Form-item>
            <Form-item prop="sheng" v-if="isAddress">
              <Select v-model="loginFrom.sheng"
                      @on-change="choseProvince"
                      label-in-value
                      placeholder="请选择省"
                      size="large">
                <Option v-for="item in province"
                        :key="item.id"
                        :value="item.id">
                  {{ item.value }}
                </Option>
              </Select>
            </Form-item>
            <Form-item prop="shi" v-if="isAddress">
              <Select v-model="loginFrom.shi"
                      @on-change="choseCity"
                      label-in-value
                      placeholder="请选择市"
                      size="large">
                <Option v-for="item in shi1"
                        :key="item.id"
                        :value="item.id">
                  {{ item.value }}
                </Option>
              </Select>
            </Form-item>
            <Form-item prop="qu" v-if="isAddress">
              <Select v-model="loginFrom.qu"
                      @on-change="choseBlock"
                      label-in-value
                      placeholder="请选择区/县"
                      size="large">
                <Option v-for="item in qu1"
                        :key="item.id"
                        :value="item.id">
                  {{ item.value }}
                </Option>
              </Select>
            </Form-item>
            <Form-item prop="tel" v-if="isTel">
              <Input type="text" size="large" v-model="loginFrom.tel" @on-keyup="inputKeyUp(loginFrom.tel)"  placeholder="请输入手机号">
                <i class="iconfont iconshouji1" slot="prepend"></i>
              </Input>
            </Form-item>
            <Form-item prop="captcha" v-if="isTel">
              <Input class="captchaInput" size="large" type="text" v-model="loginFrom.captcha" placeholder="请输入图形验证码">
                <Icon class="captcha" type="ios-lock-outline" slot="prepend"/>
                <div class="captchaImg" slot="append" @click="updataCaptchImg">
                  <img :src="captchaData.img" alt="" v-if="isImg">
                  <Icon class="imgNone" type="ios-image-outline" v-else/>
                </div>
              </Input>
            </Form-item>
            <Form-item prop="code" v-if="isTel">
              <Input class="yzm" size="large" type="text" v-model="loginFrom.code" placeholder="请输入验证码">
                <i class="iconfont iconyanzheng" slot="prepend"></i>
                <div class="btn" slot="append" v-show="show" @click="getCode">
                  <i class="iconfont iconxiaoxi1"></i>
                  <span>获取验证码</span>
                </div>
                <div class="btn" slot="append" v-show="!show">{{ count }}S后重新获取</div>
              </Input>
            </Form-item>
          </div>
          <Form-item>
            <div class="submitBtn" @click="handleSubmit('formInline')">进入考试</div>
          </Form-item>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import {mobileCode, formSubmit, formSetting, mobileCheck, getCaptcha, checkCaptcha} from "../../api/Interface";
import axios from "axios";

const TIME_COUNT = 60;
export default {
  name: "user-info-pc",
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        const reg = /^1[3-9]\d{9}$/
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };
    return {
      isImg: false,
      captchaData: {},
      isName: false,
      isSex: false,
      isAge: false,
      isDanWei: false,
      isAddress: false,
      isTel: false,
      show: true,
      count: '',
      timer: null,
      shengLabel: '',
      shiLabel: '',
      quLabel: '',
      loginFrom: {
        name: '',
        age: '',
        danwei: '',
        sex: '',
        sheng: '',
        shi: '',
        qu: '',
        tel: null,
        code: null,
        captcha: null
      },
      ageArr: [
        {
          value: '0-10岁',
          label: '0-10岁'
        },
        {
          value: '10-20岁',
          label: '10-20岁'
        },
        {
          value: '20-30岁',
          label: '20-30岁'
        },
        {
          value: '30-40岁',
          label: '30-40岁'
        },
        {
          value: '40-50岁',
          label: '40-50岁'
        },
        {
          value: '50-60岁',
          label: '50-60岁'
        },
        {
          value: '60-70岁',
          label: '60-70岁'
        },
        {
          value: '70-80岁',
          label: '70-80岁'
        },
        {
          value: '80-90岁',
          label: '80-90岁'
        },
        {
          value: '90-100岁',
          label: '90-100岁'
        },
        {
          value: '100岁+',
          label: '100岁+'
        }
      ],
      mapJson: '',
      province: '',
      sheng: '',
      shi: '',
      qu: '',
      detailedAddress: '',
      shi1: [],
      qu1: [],
      city: '',
      block: '',
      SettingData: {},
      loginFromRules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        age: [
          {required: true, message: '请选择年龄段', trigger: 'blur'}
        ],
        danwei: [
          {required: true, message: '请输入单位名称', trigger: 'blur'}
        ],
        sex: [
          {required: true, message: '请选择性别', trigger: 'blur'}
        ],
        sheng: [
          {required: true, message: '请选择省', trigger: 'blur'}
        ],
        shi: [
          {required: true, message: '请选择市', trigger: 'blur'}
        ],
        qu: [
          {required: true, message: '请选择区', trigger: 'blur'}
        ],
        tel: [
          {validator: checkPhone, trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {max: 6, min: 6, message: '验证码错误', trigger: 'blur'}
        ],
        captcha: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ],
      }
    }
  },
  created() {
    this.getFormSetting()
    this.getCityData()
  },
  mounted() {
    this.getCaptchaData()
  },
  methods: {
    //获取表单配置详情
    getFormSetting() {
      if (this.$store.state.settingData.exam.fields_need_detail.indexOf('username') !== -1) {
        this.isName = true
      }
      if (this.$store.state.settingData.exam.fields_need_detail.indexOf('mobile') !== -1) {
        this.isTel = true
      }
      if (this.$store.state.settingData.exam.fields_need_detail.indexOf('company') !== -1) {
        this.isDanWei = true
      }
      if (this.$store.state.settingData.exam.fields_need_detail.indexOf('sex') !== -1) {
        this.isSex = true
      }
      if (this.$store.state.settingData.exam.fields_need_detail.indexOf('age') !== -1) {
        this.isAge = true
      }
      if (this.$store.state.settingData.exam.fields_need_detail.indexOf('address') !== -1) {
        this.isAddress = true
      }
    },
    //提交表单
    handleSubmit(ref) {
      this.$refs[ref].validate((valid) => {
        if (valid) {
          let data = {}
          if (this.isName) {
            data.user_name = this.loginFrom.name
          }
          if (this.isDanWei) {
            data.company_name = this.loginFrom.danwei
          }
          if (this.isTel) {
            data.mobile = this.loginFrom.tel
          }
          if (this.isSex) {
            data.sex = this.loginFrom.sex
          }
          if (this.isAge) {
            data.age = this.loginFrom.age
          }
          if (this.isAddress) {
            let addressArr = [this.shengLabel, this.shiLabel, this.quLabel]
            data.address = addressArr.join(',')
          }
          this.$store.commit('userInfoData', data)
          let requestData = {
            form_id: this.$route.query.id,
            mobile: this.loginFrom.tel,
            code: this.loginFrom.code
          }
          if (this.isTel) {
            mobileCheck(requestData).then(res => {
              if (res.state) {
                if (this.$store.state.settingData.exam.code) {
                  this.$router.push('/code-pc?id=' + this.$route.query.id)
                } else {
                  this.$router.push('/explain-pc?id=' + this.$route.query.id)
                }
              } else {
                this.$Message.error(res.error);
              }
            }).catch(error => {
              console.log(error);
            })
          } else {
            if (this.$store.state.settingData.exam.code) {
              this.$router.push('/code-pc?id=' + this.$route.query.id)
            } else {
              this.$router.push('/explain-pc?id=' + this.$route.query.id)
            }
          }
        } else {
          this.$Message.error('表单验证失败');
        }
      })
    },
    //获取图形验证码
    getCaptchaData() {
      getCaptcha().then(res => {
        if (res.state) {
          this.isImg = true
          this.captchaData = res.data
        } else {
          this.$Message.error('图形验证码获取失败')
        }
      }).catch(error => {
        console.log(error);
      })
    },
    //更新图形验证码
    updataCaptchImg() {
      this.getCaptchaData()
    },
    //获取验证码
    getCode() {
      if ((/^1[3-9]\d{9}$/.test(this.loginFrom.tel)) && this.loginFrom.captcha !== '' && this.loginFrom.captcha !== null) {
        let data = {
          mobile: this.loginFrom.tel,
          form_id: this.$route.query.id,
          key: this.captchaData.key,
          captcha: this.loginFrom.captcha
        }
        mobileCode(data).then(res => {
          if (res.state) {
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000)
            }
          } else {
            this.$Message.error(res.error);
            return false
          }
        }).catch(error => {
          console.log(error);
        })
      } else {
        if (!(/^1[3-9]\d{9}$/.test(this.loginFrom.tel))) {
          this.$Message.error('请先输入正确的手机号');
        } else if (this.loginFrom.captcha === '' || this.loginFrom.captcha === null) {
          this.$Message.error('请先输入图形验证码');
        }
      }
    },
    choseSex(val) {
      this.loginFrom.sex = val
    },
    choseAge(val) {
      this.loginFrom.age = val
    },
    // 加载china地点数据，三级
    getCityData: function () {
      let that = this
      axios.get('/static/map.json').then(function (response) {
        if (response.status === 200) {
          let data = response.data
          that.province = [] //省
          that.city = []  //市
          that.block = []  //区
          // 省市区数据分类
          for (let item in data) {
            if (item.match(/0000$/)) {//省
              that.province.push({id: item, value: data[item], children: []})
            } else if (item.match(/00$/)) {//市
              that.city.push({id: item, value: data[item], children: []})
            } else {//区
              that.block.push({id: item, value: data[item]})
            }
          }
          // 分类市级
          for (let index in that.province) {
            for (let index1 in that.city) {
              if (that.province[index].id.slice(0, 2) === that.city[index1].id.slice(0, 2)) {
                that.province[index].children.push(that.city[index1])
              }
            }
          }
          // 分类区级
          for (let item1 in that.city) {
            for (let item2 in that.block) {
              if (that.block[item2].id.slice(0, 4) === that.city[item1].id.slice(0, 4)) {
                that.city[item1].children.push(that.block[item2])
              }
            }
          }
        } else {
          console.log(response.status)
        }
      }).catch(function (error) {
        console.log(typeof +error)
      })
    },
    // 选省
    choseProvince: function (e) {
      for (let index2 in this.province) {
        if (e.value === this.province[index2].id) {
          this.shi1 = this.province[index2].children
          this.loginFrom.shi = this.province[index2].children[0].id
          this.qu1 = this.province[index2].children[0].children
          this.loginFrom.qu = this.province[index2].children[0].children[0].id
          this.E = this.qu1[0].id
          this.shengLabel = e.label
          this.shiLabel = this.province[index2].children[0].value
          this.quLabel = this.province[index2].children[0].children[0].value
          this.$forceUpdate()
        }
      }
    },
    // 选市
    choseCity: function (e) {
      for (let index3 in this.city) {
        if (e.value === this.city[index3].id) {
          this.qu1 = this.city[index3].children
          this.loginFrom.qu = this.city[index3].children[0].id
          this.E = this.qu1[0].id
          this.shiLabel = e.label
          this.quLabel = this.qu1[0].value
        }
      }
    },
    // 选区
    choseBlock: function (e) {
      this.E = e.value;
      this.quLabel = e.label
    },
  
    //限制电话输入框只能输入数字
    inputKeyUp(value) {
      this.loginFrom.tel = value = value.replace(/[^\d]/g, '')
    },
  }
}
</script>

<style lang="scss" scoped>
.main-pc {
  background: url("../../assets/images/bj_pc.png") no-repeat;
  background-size: cover;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .box {
    width: 1032px;
    height: 557px;
    background-color: #ffffff;
    box-shadow: 0 2px 20px 0 rgba(0, 46, 137, 0.7);
    padding: 50px 98px 50px 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      width: 460px;
      height: 460px;
      background: url("../../assets/images/pc-login-r.png") no-repeat;
      background-size: cover;
    }

    .right {
      width: 300px;
      /*text-align: center;*/

      .title {
        color: #303133;
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 28px;
      }

      .form-box {
        .form-overflow {
          height: 300px;
          overflow-y: auto;
          padding-right: 5px;
          margin-right: -5px;

          /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
          &::-webkit-scrollbar {
            width: 3px;
            height: 8px;
          }

          /*定义滚动条轨道 内阴影+圆角*/
          &::-webkit-scrollbar-track {
            background-color: #ffffff;
          }

          /*定义滑块 内阴影+圆角*/
          &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: rgba(144, 147, 153, 0.3);
          }
        }

        .ivu-form-item-error {
          /deep/ .ivu-input {

            &:focus {
              box-shadow: none;
              border-color: #ed4014 !important;
            }
          }
        }

        .btn {
          display: flex;
          color: #3559E0;
          align-items: center;
          font-size: 12px;
          border-left: 1px solid #D2D6EB;
          padding-left: 10px;

          &:hover {
            cursor: pointer;
          }

          .iconfont {
            font-size: 18px !important;
            margin-right: 5px;
          }
        }


        .ivu-form-item {
          width: 100%;
          margin-bottom: 25px;
          margin-right: 0 !important;

          .captchaImg {
            width: 60px;
            padding: 0 3px;
            box-sizing: content-box;

            &:hover{
              cursor: pointer;
            }

            img {
              width: 100%;
            }
          }

          .captchaInput {
            /deep/ .ivu-input-group-append {
              padding: 0 !important;
            }
          }

          .ivu-input-group {
            /*height: 45px;*/

            /deep/ .ivu-input-group-prepend {
              background-color: transparent;

              .captcha {
                font-size: 22px;
                color: #515a6e !important;
              }

            }

            /deep/ .ivu-input {
              /*height: 45px;*/
              border-left: none !important;
              outline: none !important;
              -webkit-appearance: none; /*去除系统默认的样式*/
              -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/

              &:focus {
                box-shadow: none;
                border-color: #dcdee2;
              }

              &:hover {
                border-color: #dcdee2;
              }
            }

            .iconfont {
              font-size: 22px;
            }

            /deep/ .ivu-input-group-append {
              background-color: transparent;
              border-left: none !important;
            }
          }

          .yzm {
            /deep/ .ivu-input {
              border-right: none !important;
            }
          }
        }

        .address {
          .ivu-select {
            margin-bottom: 25px;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }

      .submitBtn {
        height: 40px;
        line-height: 40px;
        background: linear-gradient(270deg, #3760f4, #6286fc);
        border-radius: 4px;
        font-size: 20px;
        color: #fff;
        text-align: center;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>

